import { useMemo } from "react";
import classNames from "./MeetingParticipantPlaceholder.module.css";

export default function MeetingParticipantPlaceholder(props: {
  name?: string;
  style?: React.CSSProperties;
  className?: string;
}) {
  const initials = useMemo(() => {
    if (!props.name) {
      return;
    }
    if (!props.name.length) {
      return;
    }
    const names = props.name.split(" ");

    return (
      (names[0]?.charAt(0)?.toUpperCase() || "") +
      (names[1]?.charAt(0)?.toUpperCase() || "")
    );
  }, [props.name]);

  return (
    <div
      className={`${classNames.MeetingParticipantPlaceholder} ${
        props.className || ""
      }`}
      style={props.style}
    >
      {initials && <div className={classNames.Initials}>{initials}</div>}
      <div className={classNames.Name}>{props.name}</div>
    </div>
  );
}
